module.exports = __webpack_public_path__ + "img/nobordist-management.e5f86d57.png";